// AUTO-GENERATED by shared/generators/config_enums_generator.py — do not edit.
// RelationType — source: shared/config/permissions.config.json

export const RELATION_VALUES = ["viewer", "commenter", "editor", "owner"] as const;
export type RelationType = (typeof RELATION_VALUES)[number];

export const relationBadgeClass: Record<RelationType, string> = {
  "viewer": "bg-info/10 text-info",
  "commenter": "bg-warning/10 text-warning",
  "editor": "bg-success/10 text-success",
  "owner": "bg-primary/10 text-primary",
};

